export default __webpack_public_path__ + "static/media/ind6.f2daba07.jpg";